import PropTypes from "prop-types";

import { alignItems } from "../../../../../../../../consts";
import { t } from "../../../../../../../../services";

import { FlexContainers } from "../../../../../../../../components";
import { SimpleListSectionStyled } from "./styled";
import { Title } from "../../styled";

export const SimpleListSection = ({ title, listItems }) => {
  return (
    <SimpleListSectionStyled
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={4}>
      <Title>{t(title)}</Title>

      <ul>
        {listItems?.map((item) => {
          return <li key={item}>{item}</li>;
        })}
      </ul>
    </SimpleListSectionStyled>
  );
};

SimpleListSection.propTypes = {
  title: PropTypes.string.isRequired,
  listItems: PropTypes.arrayOf(PropTypes.string).isRequired
};
